/**
 * Program Benefits 1040 — BDU Programme Roadmap ("Key Program Features")
 * Full-bleed background art, centred heading with a gradient rule, three-up icon columns.
 */

export const PROGRAM_BENEFITS_1040_CONSTANTS = {
  METADATA_TITLES: {
    metadata: "Feature columns",
  },

  DEFAULT_ROW: {
    id: "1",
    meta_image: "",
    meta_alt_image: "",
    meta_title: "Master In-Demand Tools",
    meta_sub_title:
      "Get hands-on with Excel, Tableau and Power BI, learning at your own pace.",
    meta_priority: 1,
    meta_status: true,
  },

  PROGRAM_BENEFITS_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Heading",
      value: "Key Program Features",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "Key Program Features",
    },
    {
      fieldName: "title_start_color",
      label: "Heading colour",
      value: "#222023",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#222023",
    },
    {
      fieldName: "gradient_color_1",
      label: "Rule under heading — start",
      value: "#13344F",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#13344F",
    },
    {
      fieldName: "gradient_color_2",
      label: "Rule under heading — end",
      value: "#77B6EB",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#77B6EB",
    },
    {
      fieldName: "section_background_image",
      label: "Background image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload full-bleed background",
      defaultValue: "",
      filterCategory: "images",
    },
    {
      fieldName: "description_color",
      label: "Card title / description colour",
      value: "#222023",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#222023",
    },
    {
      fieldName: "status",
      label: "Section status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Icon",
      fieldName: "meta_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload icon (72x72)",
      defaultValue: "",
    },
    {
      header: "Icon alt",
      fieldName: "meta_alt_image",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      header: "Title",
      fieldName: "meta_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      header: "Description",
      fieldName: "meta_sub_title",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      defaultValue: "",
      rows: 3,
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      defaultValue: 1,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],
};
